/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import NavigationBar from '../components/NavBar'
import 'react-dropdown/style.css'
import DashboardForm from '../components/DashboardForm'
import triangle from '../images/triangledark.png'
import Calendar from '../calendar/Calendar'
import Clock from '../clock/ClockComponent'
import { useSelector, useDispatch } from 'react-redux';
import { current } from '@reduxjs/toolkit'
import { 
    addDrivers,
    selectDrivers
} from '../features/drivers/driversSlice'

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true    
        case null:
            return true        
        default:
            if (new Date(offboradedContent).getWeek() < new Date(selectedFunctionDate).getWeek()) {
                return false
            } else {
                return true
            }
    }
}

var displayObj = {
    'DBS2': 'Bristol',
    'DSN1': 'Swindon',
    'DEX2': 'Exeter',
    'DXP1': 'Plymouth',
    'DCF1': 'Newport',
    'CT': 'CT',
    'RT': 'RT'
}
var outsideDate = new Date()

var outsideBlockingClassName = 'visibleClassName'
var outsideCommentChecl = false
var myInterval
var todaysRoutesPermanent = []
const Dashboard = (props) => {
    const reduxDrivers = useSelector(selectDrivers)
    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+dashboard+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    var CryptoJS = require("crypto-js");
    const [ stopLoop, setStopLoop ] = useState(false)
    const [ drivers, setDrivers ] = useState(null)
    const [ selectedDate, setSelectedDate ] = useState(new Date())
    const [ schedule, setSchedule ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('Bristol - DBS2')
    const [ selectedCitySort, setSelectedCitySort ] = useState('DBS2')
    const [ topRectangles, setTopRectangles ] = useState([])
    const [ data, setData ] = useState(null)
    const [ todaysRoutes, setTodaysRoutes ] = useState([])
    const [ logicalGate, setLogicalGate ] = useState(0)
    const [ selectedModification, setSelectedModification ] = useState(null)
    const [ currentDate, setCurrentDate ] = useState(new Date())
    const [ listOfRoutes, setListOfRoutes ] = useState([])
    const [ triangleToggle, setTriangleToggle ] = useState('triangle_dashboard_page')
    const [ updateVariable, setUpdateVariable ] = useState(0)
    const [ overallDay, setOverallDay ] = useState([])
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ reload, setReload ] = useState(0)
    const [ routesBox, setRoutesBox ] = useState(null)
    const [ driverName, setDriverName ] = useState('')
    const [ commentBox, setCommentBox ] = useState([])
    const [ newComment, setNewComment ] = useState(false)
    const [ textAreaMaker, setTextAreaMaker ] = useState('')
    const [ deleteCommentBool, setDeleteCommentBool ] = useState(false)
    const [ currentComment, setCurrentComment ] = useState(null)

    // buton for locking the screen
    const [ lockBoolean, setLockBoolean ] = useState(false)
    const [ lockButton, setLockButton ] = useState(null)
    const [ blockingClassName, setBlockingClassName ] = useState('visibleClassName')
    const [ allowEditing, setAllowEditing ] = useState(false)
    const [ changedSelection, setChangedSelection ] = useState(false)

    var dayArray = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
    var monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"]

    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCitySort(props.station[0])
                // setSelectedCity()
            }
        }
    }, [])

    // change the outside date
    useEffect( () => {
        outsideDate = selectedDate
    }, [selectedDate])

    // for the lock screen
    useEffect( () => {
        outsideBlockingClassName = blockingClassName
    }, [blockingClassName])

    // keeping data outside of state for the routes
    useEffect( () => {
        todaysRoutesPermanent = todaysRoutes
    }, [todaysRoutes])

    // update parent function
    const updateParent = () => {
        let localVariable = updateVariable
        let updateValue = localVariable += 1
        setUpdateVariable(updateValue)
        setSelectedModification(null)
    }

    /// locking perma
    const handleMakeLockScreenTwo = () => {
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };

        getDataNext('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
            getDataNext('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/').then( responseOverride => {
                let overrideBool = false
                responseOverride.results.forEach( date => {
                    if ( date.date === selectedDate.toDateString()) {
                        deleteData(`https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/${date.service_id}/`)
                        setStopLoop(true)
                    }
                })
                async function postData(url = '', data = {}) {
                    let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                    let originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const response = await fetch(url, {
                        method: 'POST', 
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Token ${originalText}`
                        },
                        body: JSON.stringify(data)
                        });
        
                    return response ? response.json() : console.log('no reponse')
                };
                postData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/', {
                    date: outsideDate.toDateString(),
                }).then( response => {
                    setLockBoolean(true)
                })
            })
        })
    }

    // handle posting lock screen
    const handleMakeLockScreen = () => {
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        getDataNext('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
            getDataNext('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/').then( responseOverride => {
                let overrideBool = false
                responseOverride.results.forEach( date => {
                    if ( date.date === selectedDate.toDateString()) {
                        overrideBool = true
                        setStopLoop(true)
                    }
                })
                if (!overrideBool) {
                    async function postData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                            });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    postData('https://backendpajamas.herokuapp.com/dailyservicelocktwo/', {
                        date: outsideDate.toDateString(),
                    }).then( response => {
                        setLockBoolean(true)
                    })
                }
            })
        })
    }

    // handle unlocking
    const handleUnlock = () => {
        setAllowEditing(true)
        setLockBoolean(false)

        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        postData('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/', {
            date: outsideDate.toDateString(),
        }).then( response => {
            setLockBoolean(false)
            postData('https://backendpajamas.herokuapp.com/eighthour/', {
                date: outsideDate.toDateString(),
                locktype: 'https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/',
                lockid: response.service_id,
                current_date: new Date()
            })
        })

        getDataNext('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
            response.results.forEach( date => {
                if ( date.date === selectedDate.toDateString()) {
                    deleteData(`https://backendpajamas.herokuapp.com/dailyservicelocktwo/${date.service_id}/`)
                }
            })
        })
    }

    // make the lock button
    useEffect( () => {
        if (props.superUser || props.user_email === 'i.stoykov@h2ologistics.co.uk') {
            if (lockBoolean === false) {
                setLockButton(
                    <div 
                        className='dailyServiceLockButton'
                        onClick={handleMakeLockScreenTwo}
                    >
                        Lock Screen
                    </div>
                )
            } else {
                setLockButton(
                    <div 
                        className='dailyServiceLockButton'
                        onClick={handleUnlock}
                    >
                        Unlock Screen
                    </div>
                )
            }
        }
    }, [props, lockBoolean])

    // lock the screen
    useEffect( () => {
        setLockBoolean(false)
        setStopLoop(false)
        async function getDataNext(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };

        getDataNext('https://backendpajamas.herokuapp.com/dailyservicelocktwo/').then( response => {
            getDataNext('https://backendpajamas.herokuapp.com/dailyserviceoverridetwo/').then( responseOverride => {
                let overrideBool = false
                responseOverride.results.forEach( date => {
                    if ( date.date === selectedDate.toDateString()) {
                        overrideBool = true
                    }
                })
                if (!overrideBool) {
                    response.results.forEach( date => {
                        if ( date.date === selectedDate.toDateString()) {
                            setLockBoolean(true)
                        }
                    })
                }
            })
        })
    }, [selectedDate])

    // make the blank screen
    useEffect( () => {
        if (lockBoolean === true) {
            setBlockingClassName('invisibleClassName')
        } else {
            setBlockingClassName('modify_button_delete')
        }
    }, [lockBoolean, selectedDate])

    useEffect( () => {
        if (reduxDrivers.length > 0) {
            setDrivers(reduxDrivers)
        } else {
            async function getDataNext(url = '') {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'GET', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    }
                });
                return response ? response.json() : console.log('no reponse')
              };
          
            getDataNext('https://backendpajamas.herokuapp.com/drivers/').then( (response) => {
                response.results.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                setDrivers(response.results)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload])

    useEffect( () => {
        let theDate = selectedDate.toDateString()
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        postData('https://backendpajamas.herokuapp.com/dailservice/', {
            date: theDate,
            week: new Date(theDate).getWeek()
        }).then( response => {
            setData(response.data)
            let localArray = []
            let overallArray = []
            if (response.data) {
                response.data.drivers.forEach( element => {
                    if (determineOffboarded(element.status, theDate)) {
                        element.datesList.forEach( ele => {
                            if (selectedCitySort === 'RT' || selectedCitySort === 'CT') { 
                                if (selectedCitySort === 'CT') {
                                    if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.route === 'Classroom Training') {
                                        localArray.push(element)
                                    }
                                }
                                if (selectedCitySort === 'RT') {
                                    if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.route === 'Ride Along') {
                                        localArray.push(element)
                                    }
                                }
                            } else {
                                if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.location === selectedCitySort) {
                                    localArray.push(element)
                                }
                            }
                            if (new Date(ele.date).toDateString() === selectedDate.toDateString()) {
                                overallArray.push(ele)
                            }
                        })
                    }
                })
            }
            setTodaysRoutes(localArray)
            setOverallDay(overallArray)
            setListOfRoutes(listComponents(localArray))
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps 
    //selectedCitySort, 
    }, [selectedDate, updateVariable, schedule, blockingClassName])

    // map the data based on the change in station
    useEffect( () => {
        if (data) {
            let theDate = selectedDate.toDateString()
            let localArray = []
            let overallArray = []
            if (data) {
                data.drivers.forEach( element => {
                    if (determineOffboarded(element.status, theDate)) {
                        element.datesList.forEach( ele => {
                            if (selectedCitySort === 'RT' || selectedCitySort === 'CT') { 
                                if (selectedCitySort === 'CT') {
                                    if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.route === 'Classroom Training') {
                                        localArray.push(element)
                                    }
                                }
                                if (selectedCitySort === 'RT') {
                                    if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.route === 'Ride Along') {
                                        localArray.push(element)
                                    }
                                }
                            } else {
                                if (new Date(ele.date).toDateString() === selectedDate.toDateString() && ele.location === selectedCitySort) {
                                    localArray.push(element)
                                }
                            }
                            if (new Date(ele.date).toDateString() === selectedDate.toDateString()) {
                                overallArray.push(ele)
                            }
                        })
                    }
                })
            }
            setTodaysRoutes(localArray)
            setOverallDay(overallArray)
            setListOfRoutes(listComponents(localArray))
        }
    }, [selectedCitySort])

    // handle subbmit comment
    const handleCommentSubmit = (e) => {
        e.preventDefault()
        let myLocalDate = new Date()

        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        postData('https://backendpajamas.herokuapp.com/dailymessage/', {
            date: selectedDate.toDateString(),
            message: e.target.comment.value ? e.target.comment.value : 'none',
            station: selectedCitySort,
            name: props.user_name ? props.user_name : 'none',
            dateSubmit: new Date()
        }).then( response => {
            setErrorMessage(null)
            newComment ? setNewComment(false) : setNewComment(true)
        })
    }

    // add comment function
    const handleAddComment = () => {
        setErrorMessage(
            <div className='addCommentErrorMessage'>
                <form onSubmit={handleCommentSubmit}>
                    <input 
                        type="text" 
                        name='comment'
                        className='submitCommentTextBox'
                    />
                    <input type='submit' value='submit' className='submitCommentButton' />
                </form>
            </div>
        )
    }

    // useEffect( () => {
    //     async function putData(url = '', data={}) {
    //         let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //         let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //         const response = await fetch(url, {
    //             method: 'DELETE', 
    //             mode: 'cors',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Token ${originalText}`
    //             },
    //             body: JSON.stringify(data)
    //         });

    //         return response ? response.json() : console.log('no reponse')
    //     };
    //     putData(`https://backendpajamas.herokuapp.com/dailymessage/${81}/`, {
    //         station: 'DXP1'
    //     })
    // }, [])

    const handleDeleteComment = (e, comment) => {
        setCurrentComment(comment)
        setTextAreaMaker(comment.message)
        setDeleteCommentBool(true)
    }

    const handleTextAreaChanger = (content) => {
        setTextAreaMaker(content.target.value)
    }

    const handleDeleteCommentHere = () => {
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
        };
        if (currentComment) {
            if (currentComment !== null) {
                if (currentComment.message_id) {
                    deleteData(`https://backendpajamas.herokuapp.com/dailymessage/${currentComment.message_id}/`).then( response => {
                        newComment ? setNewComment(false) : setNewComment(true)
                        setErrorMessage(null)
                        setCurrentComment(null)
                        setDeleteCommentBool(false)
                        setTextAreaMaker('')
                    })
                }
            }
        }
    }

    const handleEditCommentHere = () => {
        async function putData(url = '', data={}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });

            return response ? response.json() : console.log('no reponse')
        };
        if (currentComment !== null) {
            if (currentComment.message_id) {
                putData(`https://backendpajamas.herokuapp.com/dailymessage/${currentComment.message_id}/`, {
                    message: textAreaMaker
                }).then( response => {
                    newComment ? setNewComment(false) : setNewComment(true)
                    setErrorMessage(null)
                    setCurrentComment(null)
                    setDeleteCommentBool(false)
                    setTextAreaMaker('')
                })
            }
        }
    }

    useEffect( () => {
        if (deleteCommentBool) {
            setErrorMessage(
                <div className='dailyServiceEditComment'>
                    <h2>Edit Message</h2>
                    <h3>Message</h3>
                    <textarea rows="4" cols="50" value={textAreaMaker} onChange={handleTextAreaChanger}></textarea>
                    <div className='buttonsBoxHere'>
                        <button className='returnButton' onClick={handleEditCommentHere}>Submit</button>
                        <button className='deleteButton' onClick={handleDeleteCommentHere}>Delete</button>
                    </div>
                </div>
            )
        }
    }, [deleteCommentBool, textAreaMaker])

    // handle grabbing the daily message
    useEffect( () => {
        let submitComment
        let commentContent = []
        submitComment = (
            <div className='addCommentDailtService' onClick={handleAddComment}>
                Add Comment
            </div>
        )
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            return response ? response.json() : console.log('no reponse')
        };
        
        getData('https://backendpajamas.herokuapp.com/dailymessage/').then( response => {
            response.results.forEach( comment => {
                if (new Date(comment.date).toLocaleDateString('en-GB') === selectedDate.toLocaleDateString('en-GB') && comment.station === selectedCitySort) {
                    if (!lockBoolean) {
                        if (comment.name) {
                            commentContent.push(
                                <div className='commentDiv' onClick={(e) => handleDeleteComment(e, comment)}>
                                    <h3>{comment.name ? comment.name : 'No Name'} ({new Date(comment.dateSubmit).toLocaleDateString('en-GB')} at {new Date(comment.dateSubmit).getHours()}:{new Date(comment.dateSubmit).getMinutes()}:{new Date(comment.dateSubmit).getSeconds()}): </h3><h4>{comment.message}</h4>
                                    <hr/>
                                </div>
                            )
                        } else {
                            commentContent.push(
                                <div className='commentDiv' onClick={(e) => handleDeleteComment(e, comment)}>
                                    <h4>{comment.message}</h4>
                                    <hr/>
                                </div>
                            )
                        }
                    } else {
                        if (comment.name) {
                            commentContent.push(
                                <div className='commentDiv'>
                                    <h3>{comment.name ? comment.name : 'No Name'} ({new Date(comment.dateSubmit).toLocaleDateString('en-GB')} at {new Date(comment.dateSubmit).getHours()}:{new Date(comment.dateSubmit).getMinutes()}:{new Date(comment.dateSubmit).getSeconds()}): </h3><h4>{comment.message}</h4>
                                    <hr/>
                                </div>
                            )
                        } else {
                            commentContent.push(
                                <div className='commentDiv'>
                                    <h4>{comment.message}</h4>
                                    <hr/>
                                </div>
                            )
                        }
                    }
                }
            })
            setCommentBox([
                <div className='dailyServiceCommentBoxContainer'>
                    <div className='commentsConatiner'>
                        {commentContent}
                    </div>
                    {submitComment}
                </div>
            ])
        })
    }, [newComment, selectedDate, selectedCitySort])

    // handle getting rid of error message
    const handleDeleteErrorGlobal = () => {
        setErrorMessage(null)
    }

    // delete the date
    const handleDeleteDate = (e, theDate, driverName) => {
        async function deleteData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });

        };
        async function postData(url='', data={}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : {'error': 'response not recieved'}
        }
        if (theDate) {
            postData(`https://backendpajamas.herokuapp.com/deletedData/`, {
                date: new Date(),
                manager_id: props.user_id,
                deletion_info: [driverName, theDate.date, theDate.location]
            }).then( response => {
                deleteData(`https://backendpajamas.herokuapp.com/schedule/${theDate.date_id}/`).then( response => {
                    handleDeleteErrorGlobal()
                    updateParent()
                })
            })
        }
    }

    // ask if thewy want to delete the date
    const handleDelete= (e, theDate, driverName) => {
        setErrorMessage(
            <div className='makeMeBig'>
                <div className='deletionObjectionTwo'>
                    <h3 id='errorMessage'>Would you like to delete? </h3>
                    <div>
                        <button className='deleteButton' onClick={(e) => handleDeleteDate(e, theDate, driverName)}>Delete</button>
                        <button className='returnButton' onClick={handleDeleteErrorGlobal}>Return</button>
                    </div>
                </div>
            </div>
        )
    }

    const listComponents = (theRoutes, sortingValue=null) => {
        var listOfRoutes
        const handleDeleteError = () => {
            setErrorMessage(null)
        }
        // modify button
        const onClick = (e, dateForChange, drivernAme) => {
            if (props.superUser) {
                setSelectedModification(dateForChange)
                setDriverName(drivernAme)
            } else {
                if (props.station.includes(dateForChange.location) || dateForChange.location === 'CT' || dateForChange.location === 'RT' || dateForChange.location === 'DCF1') {
                    setDriverName(drivernAme)
                    setSelectedModification(dateForChange)
                } else {
                    setErrorMessage(
                        <div className='errorMessageAllPages'>
                            <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                            <button className='errorButton' onClick={handleDeleteError}>Return</button>
                        </div>
                    )
                }
            }
        }
        let localArrayTwo = []
        theRoutes.forEach( ele => {
            ele.datesList.forEach( element => {
                // if (selectedCitySort !== 'RT' && selectedCitySort !== 'CT') {
                    // if (element.route !== 'Classroom Training' && element.route !== 'Ride Along') {
                        localArrayTwo.push(
                            {
                                driver: ele,
                                date: element 
                            }
                        )
                    // }
                // } else {
                //     localArrayTwo.push(
                //         {
                //             driver: ele,
                //             date: element 
                //         }
                //     )
                // }
            })
        })
        const secondsThis = (time) => {
            let splitTime = time.split(':')
            let seconds = (parseInt(splitTime[0])) * 60 * 60 + parseInt((+splitTime[1])) * 60 + parseInt((splitTime[2]))
            return seconds
        }

            let localArrayThree = []
        if (localArrayTwo.length === 0) {
            localArrayTwo.push(
                <div className='list_overall_flex_dashboard'>
                <h3>
                    Available: 0
                </h3>
            </div>
            )
        } else {
            if (sortingValue !== null) {
                if (sortingValue === 'DA Name') {
                    localArrayTwo.sort((a, b) => (a.driver.name.toLowerCase() > b.driver.name.toLowerCase()) ? 1 : -1)
                } 
                if (sortingValue === 'Route No') {
                    localArrayTwo.sort((a, b) => (a.date.routeNumber > b.date.routeNumber) ? 1 : -1)
                }
                if (sortingValue === 'Route Type') {
                    localArrayTwo.sort((a, b) => (a.date.route > b.date.route) ? 1 : -1)
                }
                if (sortingValue === 'Log In') {
                    localArrayTwo.sort((a, b) => (secondsThis(a.date.logIn_time) > secondsThis(b.date.logIn_time)) ? 1 : -1)
                }
                if (sortingValue === 'Log Out') {
                    localArrayTwo.sort((a, b) => (secondsThis(a.date.logOut_time) > secondsThis(b.date.logOut_time)) ? 1 : -1)
                }
                if (sortingValue === 'TORH') {
                    localArrayTwo.sort((a, b) => (secondsThis(a.date.timeDifference[0]) < secondsThis(b.date.timeDifference[0])) ? 1 : -1)
                }
                if (sortingValue === 'Mileage') {
                    localArrayTwo.sort((a, b) => (a.date.finish_mileage > b.date.finish_mileage) ? -1 : 1)
                }
                if (sortingValue === 'Support') {
                    localArrayTwo.sort((a, b) => (parseFloat(a.date.supportSum.slice(3)) < parseFloat(b.date.supportSum.slice(3))) ? 1 : -1)
                }
                if (sortingValue === 'Deductions') {
                    localArrayTwo.sort((a, b) => (parseFloat(a.date.deductionSum.slice(3)) < parseFloat(b.date.deductionSum.slice(3))) ? 1 : -1)
                }
            } else {
                localArrayTwo.sort((a, b) => (a.driver.name > b.driver.name) ? 1 : -1)
            }

            const routeName = (routeString) => {
                let name = ''
                switch (routeString) {
                    case 'Full Standard Van Route':
                        name = 'Standard Route'
                        break;
                    case 'Full Large Van Route':
                        name = 'Large Route'
                        break;
                    default:
                        name = routeString    
                }
                if (name === '0') {
                    name = '--'
                } return name
            }

            const makePrettyTimes = (amountOfTime) => {
                if (amountOfTime === '0:00:00') {
                    return '--'
                } else {
                    let localTime = amountOfTime.match(/\d?[^:]/)
                    if (parseInt(localTime[0]) > 9) {
                        return (<h3 className='moreThanTenGate'>{amountOfTime}</h3>)
                    }
                    else {
                        return amountOfTime
                    }
                }
            }
            localArrayTwo.forEach( ele => {
                localArrayThree.push(
                    <div className='list_overall_flex_dashboard'>
                        <div className='elements_in_list_dashboard_names'>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{selectedCitySort}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.driver.name}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.routeNumber === '0' ? '--' : ele.date.routeNumber}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{routeName(ele.date.route)}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.logIn_time.slice(0, 5)}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.logOut_time.slice(0, 5)}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{makePrettyTimes(ele.date.timeDifference[0])}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.finish_mileage > 0 ? ele.date.finish_mileage - ele.date.start_mileage : 0}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.supportSum ? `${parseFloat(ele.date.supportSum.slice(3)).toFixed(2)}£` : '--'}</h4>
                            </div>
                            <div className='list_spacer_content'>
                                <h4 className='remove_h3_padding'>{ele.date.deductionSum ? `${parseFloat(ele.date.deductionSum.slice(3)).toFixed(2)}£` : '--'}</h4>
                            </div>
                        </div>
                        <div className='visibleClassName'>
                            <button className='modify_button' onClick={(e, elements) => onClick(e, ele.date, ele.driver.name)}>
                                <h4>Modify</h4>
                            </button>
                            <button className={outsideBlockingClassName} onClick={(e, elements) => handleDelete(e, ele.date, ele.driver.name)}>
                                <h4 >x</h4>
                            </button>
                        </div>
                    </div>
                )
            })
        }
        listOfRoutes = localArrayThree
        return (
            <>
                {listOfRoutes}
            </>
        )
    }

    const handleSorting = (e, targetBox) => {
        setListOfRoutes(listComponents(todaysRoutesPermanent, targetBox))
    }

    useEffect( () => {
        let localArray = []
        let labelArray =[`${selectedCitySort}`, 'DA Name', 'Route No', 'Route Type', 'Log In', 'Log Out', 'TORH', 'Mileage', 'Support', 'Deductions']
        for (let i = 0; i < 10; i++) {
            localArray.push(
                <div className='dashboard_top_rectangles' onClick={(e, targetValue) => handleSorting(e, labelArray[i])}>
                    <h4 className='remove_h3_padding' >{labelArray[i]}</h4>   
                </div>
            )
        }
        setTopRectangles(localArray)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCity])

    // set city
    const handleSelectCity = (e, city) => {
        setSelectedCity(city)
        if (city === 'Bristol - DBS2') {
            setSelectedCitySort('DBS2')
        } else if (city === 'Swindon - DSN1') {
            setSelectedCitySort('DSN1')
        } else if (city === 'Exeter - DEX2'){
            setSelectedCitySort('DEX2')
        } else if (city === 'Newport - DCF1'){
            setSelectedCitySort('DCF1')
        } else if ( city === 'CT') {
            setSelectedCitySort('CT')
        } else if (city === 'RT') {
            setSelectedCitySort('RT')
        } else {
            setSelectedCitySort('DXP1')
        }
        let x = logicalGate
        x = x+1
        setLogicalGate(x)
    }

    // map data into the top box
    useEffect( () => {
        if (overallDay.length > 0) {
            let routesTotal = overallDay.length
            let overallRoutes = 0
            let mfnRoutes = 0
            let fullStandardRoutes = 0
            let fullLargeRoutes = 0
            let transportationRoute = 0
            let missortRout = 0
            let classroomTraining = 0
            let rideAlong = 0
            let sweeper = 0
            let none = 0
            let jumper = 0
            let deductions = 0
            let support = 0
            let manager = 0
            let totalMiles = 0
            let totalHours = 0
            let halfStatdardRoutes = 0

            function timeStringToFloat(time) {
                var hoursMinutes = time.split(/[:]/);
                var hours = parseInt(hoursMinutes[0]);
                var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1]) : 0;
                return hours + minutes / 60;
            }

            overallDay.forEach( ele => {
                if (ele.location === selectedCitySort) {
                    switch(ele.route) {
                        case 'Full Standard Van Route':
                            fullStandardRoutes++
                            overallRoutes++
                            break;            
                        case 'Full Large Van Route':
                            fullLargeRoutes++
                            overallRoutes++
                            break;            
                        case 'Transportation Route':
                            transportationRoute++
                            overallRoutes++
                            break;            
                        case 'MFN Route':
                            mfnRoutes++
                            overallRoutes++
                            break;     
                        case 'Missort Route':
                            missortRout++
                            overallRoutes++
                            break;
                        case 'Classroom Training':
                            classroomTraining++
                            overallRoutes++
                            break;
                        case 'Ride Along':
                            rideAlong++
                            overallRoutes++
                            break;
                        case 'Sweeper':
                            sweeper++
                            overallRoutes++
                            break;                  
                        case 'None':
                            none++
                            // overallRoutes++
                            break;  
                        case 'Manager':
                            manager++
                            overallRoutes++
                            break; 
                        case 'Half Standard Van Route':
                            halfStatdardRoutes++
                            overallRoutes++  
                            break;
                        case 'Jumper':
                            overallRoutes++ 
                            jumper++
                            break;
                        default:
                            // overallRoutes++  
                            break;
                    }
                    support += parseFloat(ele.supportSum.slice(3))
                    deductions += parseFloat(ele.deductionSum.slice(3))
                    totalMiles += ele.finish_mileage
                    totalHours += timeStringToFloat(ele.timeDifference[0])
                }
            })
            let randomCount = 0
            const handleMakingContent = () => {
                let localArray = []
                fullStandardRoutes > 0 ? localArray.push(<h4>Full Standard Van Route: {fullStandardRoutes}</h4>) : randomCount++
                fullLargeRoutes > 0 ? localArray.push(<h4>Full Large Van Route: {fullLargeRoutes}</h4>) : randomCount++
                transportationRoute > 0 ? localArray.push(<h4>Transportation Route: {transportationRoute}</h4>) : randomCount++
                mfnRoutes > 0 ? localArray.push(<h4>MFN Rounte: {mfnRoutes}</h4>) : randomCount++
                missortRout > 0 ? localArray.push(<h4>Missort Route: {missortRout}</h4>) : randomCount++
                classroomTraining > 0 ? localArray.push(<h4>Classroom Training: {classroomTraining}</h4>) : randomCount++
                rideAlong > 0 ? localArray.push(<h4>Ride Along: {rideAlong}</h4>) : randomCount++
                sweeper > 0 ? localArray.push(<h4>Sweeper: {sweeper}</h4>) : randomCount++
                manager > 0 ? localArray.push(<h4>Manager: {manager}</h4>) : randomCount++
                halfStatdardRoutes > 0 ? localArray.push(<h4>Half Standard Van Route: {halfStatdardRoutes}</h4>) : randomCount++
                jumper > 0 ? localArray.push(<h4>Jumper: {jumper}</h4>) : randomCount++
                none > 0 ? localArray.push(<h4>None: {none}</h4>) : randomCount++
                return localArray
            }
            const handleMakingDeductionsContent = () => {
                let localArray = []
                deductions > 0 ? localArray.push(<h4>Total deductions: {Math.round((deductions + Number.EPSILON) * 100) / 100}£</h4>) : randomCount++
                support > 0 ? localArray.push(<h4>Total support: {Math.round((support + Number.EPSILON) * 100) / 100}£</h4>) : randomCount++
                return localArray
            }
            setRoutesBox(
            <div className='dashboard_route_type_list'>
                <div className='topContentDailyServiceLists'>
                    <h4>Overall: {overallRoutes}</h4>
                    <h4>Total Mileage: {totalMiles}</h4>
                    <h4>Average Hours: {overallRoutes > 0 ? parseFloat(totalHours/overallRoutes).toFixed(2) : 0}</h4>
                    {handleMakingDeductionsContent()}
                </div>
                <div className='lineTheseUp'>
                    {handleMakingContent()}
                </div>
            </div>
            )
        } else {
            setRoutesBox(<div className='dashboard_route_type_list'></div>)
        }
    }, [overallDay, selectedCitySort, data])

/////****************************************** List Component ********************************** */


// handling the clock
useEffect( () => {
    clearInterval(myInterval)
    const timeFunction = () => {
        let setTime = () => {
            setCurrentDate(new Date())
        }
        myInterval = setInterval( setTime, 1000)
    }
    timeFunction()
}, [])

useEffect( () => {
    if (!lockBoolean && !allowEditing && !stopLoop) {
        let newDate = new Date(outsideDate)
        let newFinalDate = newDate.setDate(newDate.getDate() + 2)
        if (currentDate > newFinalDate) {
            handleMakeLockScreen()
        }
    }
}, [currentDate])

// calendar selectiopn function
const returnDateFunction = (selectedDate) => {
    setChangedSelection(true)
    setSelectedDate(selectedDate)
    setTriangleToggle('triangle_dashboard_page')
}

// calendar
var onClickVar

//  toggle triangle
const handleTogleTriangle = () => {
    triangleToggle === 'triangle_dashboard_page_down' ? setTriangleToggle('triangle_dashboard_page') : setTriangleToggle('triangle_dashboard_page_down')
}

// make calendar and reset triangle
if (triangleToggle === 'triangle_dashboard_page_down') {
    onClickVar = (
        <div className='shadow_calendar_class_two'>
            <Calendar 
                startingDay='Sun'
                returnDate={returnDateFunction}
                currentSelection={selectedDate}
            />
        </div>
    )
}

// clock and calendar
var clockAndCalendar
clockAndCalendar = (
    <div className='clock_and_calendar'>
        <h3 className='nav_current_date'>
            Week: {currentDate.getWeek()}
            {<br />}
            Today: {currentDate.toLocaleDateString('en-GB')}
            {<br />}
            Date Selected: {selectedDate.toLocaleDateString('en-GB')}
            {<br />}
            {currentDate.toLocaleTimeString()}
        </h3>
        <h3 className='calendar_date_picker_dashboard'>
            <div className='shadow_calendar_class'>
                Date Selected: {' '} {selectedDate.toLocaleDateString('en-GB')}
                <span onClick={handleTogleTriangle}><img src={triangle} alt="triangle" className={triangleToggle}/></span>
                {onClickVar}
            </div>
        </h3>
    </div>
)

    return (
        <>
        {errorMessage}
            <div className='home_content'>
                <NavigationBar 
                title='Daily Service'
                superUser={props.superUser ? true : false}
                email={props.user_email}
                />
                <div className='clockContainer'>
                    <Clock 
                        currentDate={currentDate}
                        selectedDate={selectedDate}
                        changedSelection={changedSelection}
                    />
                </div>
                <div className='main_content_dashboard'>
                    <div className='dropdownDailyService'>
                        <div id="demoHomeDaily" >
                            <div className="wrapper">
                                <div className="content">
                                    <ul>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'Bristol - DBS2')}><li>DBS2</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'Swindon - DSN1')}><li>DSN1</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'Exeter - DEX2')}><li>DEX2</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'Plymouth - DXP1')}><li>DXP1</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'Newport - DCF1')}><li>DCF1</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'CT')}><li>CT</li></a>
                                        <a href="#0" onClick={(e, city) => handleSelectCity(e, 'RT')}><li>RT</li></a>
                                    </ul>
                                </div>
                                <div className="parent" >{selectedCitySort}</div>
                            </div>
                        </div>
                    </div>
                    {routesBox}
                    {clockAndCalendar}
                    <div className='top_rectangles_container'>
                        {topRectangles}
                    </div>  
                    <div className='list_of_routes_dashboard'>
                        {listOfRoutes}
                    </div>  
                    <hr />
                    <DashboardForm 
                        otherSelection={selectedModification}
                        data={data}
                        selectedCitySort={selectedCitySort}
                        drivers={drivers}
                        dates={schedule}
                        updateParentFunction={updateParent}
                        managerStation={props.station ? props.station : null}
                        driverName={driverName}
                        locked={lockBoolean}
                        userId={props.user_id}
                    />
                    {props.user_email === "invoices@h2ologistics.co.uk" ? null : commentBox}
                    {lockButton}
                </div>
            </div>
        </>
    )
}

export default Dashboard